import type { RouteRecordRaw } from 'vue-router';

export const programsRoute: RouteRecordRaw = {
  path: '/programs',
  name: 'Programs',
  component: () => import('./pages/ProgramsPage.vue'),
  meta: {
    layout: 'main',
    // `:get`, а не `:list` — див. коментар біля пункту меню «Спеціальності» в
    // MainLayout.vue: `programs:list` роздано ще й заради фільтра студентів.
    authorize: ({ isGranted }) => isGranted('ugi:core:programs:get'),
  },
};
